import DEFAULT_AVATAR from './avatar.png'
import DEFAULT_ERROR_IMAGE from './noimage.png'

const DEFAULT_IMG = {
    AVATAR: DEFAULT_AVATAR,
    ERROR_IMAGE: DEFAULT_ERROR_IMAGE,
}

export default DEFAULT_IMG
